import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { useCasesGeneralNotification } from './hook';
import { CasesGeneralNotificationProps } from './props';

export const CasesGeneralNotification = (
    props: CasesGeneralNotificationProps
) => {
    const { formik } = useCasesGeneralNotification(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Notificación cliente
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
                <FieldText
                    label="Email de notificación"
                    name="notificationClient"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.notificationClient}
                    errors={formik.errors.notificationClient}
                    value={formik.values.notificationClient}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
